export { LayoutDualColModule } from './layout-dual-col.module';
export { LayoutDualColComponent } from './layout-dual-col.component';
export {
  LayoutDualColAsideDirective,
  LayoutDualColSharedDirective,
  LayoutDualColDrawerContentDirective,
} from './layout-dual-col-sections';
